import React from "react";
import FullscreenLoader from "./FullscreenLoader";

export default function LanguageSwitchOverlay({ show }) {
  if (!show) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10050,
        pointerEvents: "auto",
      }}
    >
      <FullscreenLoader />
    </div>
  );
}
